// removed by extract-text-webpack-plugin
module.exports = {"illustration":"src-components-modules-Hero-HeroIllustration-style----illustration-module---illustration---OByMU textAlign-center centered"};


//////////////////
// WEBPACK FOOTER
// ./src/components/modules/Hero/HeroIllustration/style/illustration.module.css
// module id = 251
// module chunks = 13500351136367 116229058454702 221662759943617